import React, { CSSProperties } from "react";
import { FiPlus, FiUser } from "react-icons/fi";
import { FaExclamation } from "react-icons/fa";
import { getThemeColors, getComponentColors, Theme } from "../../theme/colors";
import { useNavigate } from "react-router-dom";

interface DevMenuPopupProps {
  isOpen: boolean;
  onClose: () => void;
  clearChatHistory: () => void;
  username: string;
  colorMode: string;
  devNumber: number;
}

export const DevMenuPopup: React.FC<DevMenuPopupProps> = ({
  isOpen,
  onClose,
  clearChatHistory,
  username,
  colorMode,
  devNumber,
}) => {
  const navigate = useNavigate();
  const currentColors = getThemeColors(username, colorMode as Theme);
  const sidebarColors = getComponentColors("sidebar", colorMode as Theme);

  const buttonStyle: CSSProperties = {
    borderWidth: "1px",
    borderColor: currentColors.border,
    borderRadius: "4px",
    padding: "0.5rem",
    justifyContent: "flex-start",
    transition: "all ease 0.5s",
    backgroundColor: "transparent",
    cursor: "pointer",
    color: currentColors.text,
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  const buttonHoverStyle: CSSProperties = {
    backgroundColor: sidebarColors.buttonHover || currentColors.buttonHover,
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: currentColors.background,
          borderRadius: "8px",
          padding: "1.5rem",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          minWidth: "300px",
          maxWidth: "90vw",
          border: `1px solid ${currentColors.border}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          style={{
            color: currentColors.text,
            margin: "0 0 1rem 0",
            fontSize: "1.1rem",
            fontWeight: "600",
          }}
        >
          Dev Menu
        </h3>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
          }}
        >
          {devNumber !== 99 && (
            <>
              <button
                style={{
                  ...buttonStyle,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "0.75rem 1rem",
                  backgroundColor: "transparent",
                  border: `1px solid ${currentColors.border}`,
                }}
                onClick={() => {
                  onClose();
                  navigate(`/upload`);
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    buttonHoverStyle.backgroundColor || "";
                }}
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <FiPlus size={16} />
                <span>Upload Tests</span>
              </button>
              <button
                style={{
                  ...buttonStyle,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "0.75rem 1rem",
                  backgroundColor: "transparent",
                  border: `1px solid ${currentColors.border}`,
                }}
                onClick={() => {
                  onClose();
                  clearChatHistory();
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    buttonHoverStyle.backgroundColor || "";
                }}
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <FaExclamation />
                <span>Clear Chat History</span>
              </button>
            </>
          )}
          <button
            style={{
              ...buttonStyle,
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.75rem 1rem",
              backgroundColor: "transparent",
              border: `1px solid ${currentColors.border}`,
            }}
            onClick={() => {
              onClose();
              navigate("/user_manager");
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                buttonHoverStyle.backgroundColor || "";
            }}
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            <FiUser />
            <span>User Management</span>
          </button>
          <button
            style={{
              ...buttonStyle,
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.75rem 1rem",
              backgroundColor: "transparent",
              border: `1px solid ${currentColors.border}`,
            }}
            onClick={() => {
              onClose();
              navigate(`/rdm`);
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                buttonHoverStyle.backgroundColor || "";
            }}
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            <FiPlus size={16} />
            <span>RDM</span>
          </button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              padding: "0.5rem 1rem",
              backgroundColor: "transparent",
              border: `1px solid ${currentColors.border}`,
            }}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                buttonHoverStyle.backgroundColor || "";
            }}
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "transparent")
            }
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
